module.exports = __webpack_public_path__ + "img/appIcon-menu--AccountDashboard.5082ca74.svg";